import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { NotificationsEntity } from './notifications.entity';
import { NotifyResponseModel } from './notify-res-model';

@Injectable()
export class NotificationsService {
    constructor(
        @InjectRepository(NotificationsEntity)
        private notifyRepo:Repository<NotificationsEntity>
    ) {}

    async getNotifications(queryParams,userId,request:Request): Promise<NotifyResponseModel> {
        const response = new NotifyResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const data = await this.notifyRepo.find({
                    where:{userId:userId},
                    order:{createdAt:"DESC"}
                })
                if(data) {
                    response.status = true;
                    response.data = data;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                } 
            } else {
                const data = await this.notifyRepo.find({
                    where:{userId:userId},
                    order:{createdAt:"DESC"}
                })
                if(data) {
                    response.status = true;
                    response.data = data;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch(error) {
            throw error;//new ErrorResponse(99998, error);
        }
    }
     
}
